<template>
  <div class="sku-table-box">
    <el-tag type="warning" v-if="unEditSku && !isReadOnly">商品已入库，单品编号不可修改</el-tag>
    <el-form ref="skuTableFormRef" :disabled="isReadOnly" :model="skuTableForm" size="small">
      <el-table :data="skuTableForm.tableData" border :key="tablehead.length + buttonDisabled" :span-method="arraySpan">
        <el-table-column align="center" min-width="172px" :key="key" :prop="key" :label="item"
          v-for="(item, key) in tablehead">
          <template slot="header">
            <template v-if="blueRequiedKeys.includes(key)">
              <span style="color: #FF3F3F;">*</span><span style="color: #008CFF; font-weight: bold;">{{ item }}</span>
            </template>
            <template v-else-if="requiedKeys.includes(key)">
              <span style="color: #FF3F3F;">*</span><span>{{ item }}</span>
              <el-button v-if="key === 'spuSn'" :disabled="buttonDisabled" class="get-button" @click="handleGetGoodsSn"
                size="mini" type="primary">系统生成</el-button>
            </template>
            <template v-else>
              {{ item }}
            </template>
          </template>
          <template slot-scope="scope">
            <template v-if="skuKeys.includes(key)">
              <el-form-item>
                {{ scope.row[key] }}
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item :prop="`tableData.${scope.$index}.${key}`" :rules="getRules(item, key)">
                <el-input @input="handleInput(key, scope.$index)" @blur="handleBlur(key, scope.$index)"
                  :disabled="key !== 'spuSn' ? isReadOnly : (isReadOnly || unEditSku)"
                  v-model="skuTableForm.tableData[scope.$index][key]" clearable :placeholder="'请输入' + item"></el-input>
              </el-form-item>
            </template>
          </template>
        </el-table-column>
        <el-table-column align="center" width="128px" label="规格图片" v-if="openSkuImg">
          <template slot="header">
            <template>
              <span style="color: #FF3F3F;">*</span><span>规格图片</span>
            </template>
          </template>
          <template slot-scope="scope">
            <el-form-item :prop="`tableData.${scope.$index}.spuImgList`"
              :rules="[{ required: true, message: '请上传规格图片', trigger: 'change' }]">
              <xiaobu-upload-img :ref="'spuImgRef' + scope.$index" class="img-upload" :openCropper="true"
                @imgChange="handleImgChange(scope.$index)" :max="1"
                :imgList="skuTableForm.tableData[scope.$index].spuImgList"></xiaobu-upload-img>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </div>
</template>
<script>
import XiaobuUploadImg from "@/components/upload-img/index.vue"
import { spuApi } from "@/api"

export default {
  components: {
    XiaobuUploadImg
  },
  props: {
    // 商品编号
    goodsSn: {
      type: String,
      default: ""
    },
    isReadOnly: {
      type: Boolean,
      default: true
    },
    // 是否开启规格图片
    openSkuImg: {
      type: Boolean,
      default: false
    },
    skuList: {
      type: Array,
      default: () => {
        return []
      }
    },
    format: {
      type: Object,
      default: () => {
        return { // 字段属性
          skuAttrId: "skuAttrId",
          skuAttrName: "skuAttrName",
          skuValueList: "skuValueList",
          skuValue: "skuValue",
          skuValueId: "skuValueId"
        }
      }
    },
    //编辑时获取之前已经存在的列表数据
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    unEditSku: {
      type: Boolean,
      default: true
    }
  },
  data() {
    // 校验单品编号
    const checkSpuSn = (rule, value, callback) => {
      const index = rule.field.split(".")[1]
      let spuSnNum = 0 // 记录单品型号个数
      for (let i = 0; i < this.skuTableForm.tableData.length; i++) {
        const item = this.skuTableForm.tableData[i]
        if (item.spuSn === value) {
          spuSnNum++
        }
        if (spuSnNum >= 2) { break }
      }
      if (spuSnNum >= 2) {
        callback("单品型号不能重复")
        return
      }

      spuApi.judgeExist({ spuSn: value, spuId: this.skuTableForm.tableData[index].spuId }).then((data) => {
        if (data.validateResult) {
          callback()
        } else {
          callback(data.msg)
        }
      }).catch(err => {
        callback()
      })
    }
    return {
      checkSpuSn,
      blueRequiedKeys: ["salesPrice", "costPrice"], //表头蓝色字体必填
      requiedKeys: ["inVentoryAlertNum", "spuSn"],
      skuTableForm: {
        tableData: [] //表格数据
      }, //skuTableForm表单
      tablehead: {}, //表头数据
      otherTableHeader: {
        costPrice: "成本价格(元)",
        salesPrice: "销售价格(元)",
        inVentoryAlertNum: "库存预警值",
        spuSn: "编号"
      },
      spanArr: []
    }
  },
  watch: {
    //监听笛卡尔规格列表数据
    descartesArray: {
      handler(val) {
        //无其他表头时
        if (Object.keys(this.otherTableHeader).length === 0) {
          this.skuTableForm.tableData = val.map((item, index) => {
            return {
              ...item,
              spuImgList: [],
              "spuImg": (this.list[index] && this.list[index].spuImg) || (this.skuTableForm.tableData[index] && this.skuTableForm.tableData[index].spuImg) || "",
              "spuId": null
            }
          })
          return
        }

        // 未开启规格值时 默认展示一行
        if (val.length === 0) {
          const obj = {}
          Object.keys(this.otherTableHeader).forEach(key => {
            obj[key] = this.list[0] ? this.list[0][key] : null
          })
          // 寻找单品编号一致的目标元素
          let target = {}
          if (obj.spuSn && this.list.length > 0) {
            target = this.list.find(item => {
              return item.spuSn === obj.spuSn
            })
          }
          this.skuTableForm.tableData = [{ ...obj, spuImg: "", spuImgList: [], "spuId": target.spuId || null }]
          return
        }
        // 有其他表头
        const arr = []
        val.forEach((item, index) => {
          //设置tableData的值
          const obj = {}
          Object.keys(this.otherTableHeader).forEach(key => {
            // 实现修改 规格项时 已填数据不删除
            if (this.skuTableForm.tableData.length > 0 && this.skuTableForm.tableData[index]) {
              obj[key] = this.skuTableForm.tableData[index][key] || (this.list[index] ? (this.list[index][key] || null) : null)
            } else if (this.list.length > 0 && this.list[index]) {
              obj[key] = this.list[index][key] || null
            } else {
              obj[key] = null
            }
          })

          // 寻找单品编号一致的目标元素
          let target = {}
          if (obj.spuSn && this.list.length > 0) {
            target = this.list.find(item => {
              return item.spuSn === obj.spuSn
            })
          }
          arr.push({
            ...obj,
            ...item,
            "spuImg": (this.list[index] && this.list[index].spuImg) || (this.skuTableForm.tableData[index] && this.skuTableForm.tableData[index].spuImg) || "",
            "spuId": target.spuId || null
          })
        })

        this.skuTableForm.tableData = arr
      },
      immediate: true
    },
    // 监听规格头部变化
    skuTableHeader: {
      handler: function(val) {
        const skuHeader = JSON.parse(JSON.stringify(val))
        this.tablehead = Object.keys(val).length === 0 ? this.otherTableHeader : Object.assign(skuHeader, this.otherTableHeader)
      },
      immediate: true
    },

    //监听表格数据变化
    "skuTableForm.tableData": {
      handler(val) {
        //计算位置
        this.getSpanArr(val)
      },
      deep: true
    }
  },
  computed: {
    buttonDisabled() {
      return this.isReadOnly || this.unEditSku
    },
    //规格表头
    skuKeys() {
      return Object.keys(this.skuTableHeader)
    },
    // 获取sku表头
    skuTableHeader() {
      if (this.skuList.length === 0) {
        return {}
      }
      const skuTableHeader = {}
      const item = this.skuList[0]
      for (let j = 0; j < item.length; j++) {
        const childItem = item[j]
        //解决id存数字的话  对象会被重新排序
        skuTableHeader["syx" + childItem[this.format.skuAttrId]] = childItem[this.format.skuAttrName]
      }
      return skuTableHeader
    },
    // 获取笛卡尔积列表
    descartesArray() {
      const descartesTable = []
      for (let i = 0; i < this.skuList.length; i++) {
        const item = this.skuList[i]
        const obj = {
          skuItemList: []
        }
        for (let j = 0; j < item.length; j++) {
          const childItem = item[j]
          //解决id存数字的话  对象会被重新排序 用于前端显示
          obj["syx" + childItem[this.format.skuAttrId]] = childItem[this.format.skuValue]

          // 用于存储数据
          obj.skuItemList.push(childItem)
        }
        descartesTable.push(obj)
      }
      return descartesTable
    }
  },
  methods: {
    // 生产spu编码
    handleGetGoodsSn() {
      for (let i = 0; i < this.skuTableForm.tableData.length; i++) {
        this.$set(this.skuTableForm.tableData, i, {
          ...this.skuTableForm.tableData[i],
          spuSn: this.goodsSn + String(i + 1).padStart(2, "0")
        })
        this.$refs.skuTableFormRef.validateField(`tableData.${i}.spuSn`)
      }

    },
    // 失去焦点事件
    handleBlur(key, index) {
      if (key === "costPrice" || key === "salesPrice") {
        // 若输入值不为空
        if (this.skuTableForm.tableData[index][key]) {
          // 将输入值转换为浮点数
          const num = parseFloat(this.skuTableForm.tableData[index][key])
          // 判断是否为有效的数字
          if (!isNaN(num)) {
            // 保留两位小数
            this.skuTableForm.tableData[index][key] = num.toFixed(2)
          }
        }
      } else if (key === "inVentoryAlertNum") { // 库存预警数量只能是数字
        const str = this.skuTableForm.tableData[index][key]
        // 特殊情况处理：空字符串或单个0
        if (str === "0" || str === "") {
          this.skuTableForm.tableData[index][key] = "0"
          return
        }
        // 去除开头的0
        const result = str.replace(/^0+/, "")
        // 如果去除后变成空字符串，说明原字符串全是0，返回单个0
        if (result === "") {
          this.skuTableForm.tableData[index][key] = "0"
          return
        }
        this.skuTableForm.tableData[index][key] = result
      }
    },
    // 输入事件
    handleInput(key, index) {
      // 价格只能 小数点2位
      if (key === "costPrice" || key === "salesPrice") {
        let value = this.skuTableForm.tableData[index][key]
        // 移除非数字和小数点的字符
        value = value.replace(/[^\d.]/g, "")
        // 处理多个小数点的情况
        const parts = value.split(".")
        if (parts.length > 2) {
          value = parts[0] + "." + parts[1]
        }
        // 保留最多两位小数
        const match = value.match(/^\d+(\.\d{0,2})?/)
        if (match) {
          this.skuTableForm.tableData[index][key] = match[0]
        } else {
          this.skuTableForm.tableData[index][key] = ""
        }
      } else if (key === "inVentoryAlertNum") { // 库存预警数量只能是数字
        this.skuTableForm.tableData[index][key] = this.skuTableForm.tableData[index][key].replace(/[^\d]/g, "")
      }
    },
    // 获取校验规则
    getRules(item, key) {
      if (key === "spuSn") {
        return [
          { required: true, message: "请输入" + item, trigger: "blur" },
          { validator: this.checkSpuSn, trigger: "blur" }
        ]
      } else {
        return [{ required: true, message: "请输入" + item, trigger: "blur" }]
      }
    },
    // 获取表格数据
    getTableList() {
      return new Promise((resolve, reject) => {
        this.$refs.skuTableFormRef.validate(valid => {
          if (valid) {
            resolve(this.skuTableForm.tableData)
          } else {
            reject()
          }
        })
      })
    },
    // 规格图片改变事件
    handleImgChange(index) {
      this.$nextTick(() => {
        this.$set(this.skuTableForm.tableData[index], "spuImgList", this.$refs["spuImgRef" + index].getImgList())
        this.$refs.skuTableFormRef.validateField(`tableData.${index}.spuImgList`)
      })
    },
    // 合并行方法  返回数组的形式
    arraySpan({ row, column, rowIndex, columnIndex }) {
      if (this.skuList.length === 0) {
        return [1, 1]
      }
      // 占用行的格子数
      const _row = this.spanArr[rowIndex][columnIndex]
      // 有占用行 则占用1列  没有则被合并 返回 0 0 不占用格子
      const _col = _row > 0 ? 1 : 0
      return [_row, _col]
    },
    //计算位置的方法 来得到 spanArr 数列   data 为表格数据
    getSpanArr(val) {
      const data = JSON.parse(JSON.stringify(val))
      // 记录第一次出现 该值时 在第几行  用于记录该格子下方有几个值一样的个数 然后让其占用对于行的格子数
      const posObj = {} // 对象类型 是因为要记录多个 skuKey的数据
      // skuFieldList 为规格字段名 按顺序 与表格从左往右顺序对应
      const skuFieldList = this.skuKeys
      //遍历表格行数
      for (var i = 0; i < data.length; i++) {
        //存储要合并的数据
        this.spanArr[i] = []
        // 总字段长度
        const keysLength = Object.keys(data[i]).length
        // 遍历所有字段
        for (let j = 0; j < keysLength; j++) {
          // 当开始遍历非规格的数据时 直接返回 1 表示占用一个格子 不合并
          if (j >= skuFieldList.length) {
            this.spanArr[i][j] = 1
            continue
          }
          // 记录当前键名 skuFieldList 已经是按表格规格名顺序排列的规格字段数组
          const key = skuFieldList[j]
          if (i === 0) {
            this.spanArr[i][j] = 1
            posObj[key] = i //没出现一样的，位置重新标记
          } else {
            // 判断前面的所有规格字段 当前行的值 与上一行的值是否相同 都相同才合并单元格
            let flag = true
            if (j > 0) {
              // 如果规格名前面的所有字段的上一行的值与当前行不一致 则不是同款东西，不做合并单元格处理
              for (let w = j - 1; w >= 0; w--) {
                const preKey = skuFieldList[w]
                if (data[i][preKey] !== data[i - 1][preKey]) {
                  flag = false
                  break
                }
              }
            }
            // 判断当前元素与上一个元素是否相同 如果相同，此行的span设置为占用0格  上一行的占用格数 +1
            if (data[i][key] === data[i - 1][key] && flag) {
              this.spanArr[posObj[key]][j] += 1 //将第一个出现该值的 格子+1个占用格
              this.spanArr[i][j] = 0
            } else {
              this.spanArr[i][j] = 1
              posObj[key] = i //没出现一样的，位置重新标记
            }
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.sku-table-box {
  .get-button {
    margin-left: 12px;
  }

  ::v-deep .img-upload {

    .el-upload,
    .el-upload-list__item {
      width: 108px !important;
      height: 108px !important;

      .el-icon-plus {
        display: block;
        line-height: 108px;
      }

      .el-upload-list__item-do {
        margin-left: 12px;

        &:first-child {
          margin-left: 0;
        }
      }
    }
  }
}
</style>